<template>
  <div>
    <div slot="title">
      <h2>Reporte de Porcentaje de Evaluaciones</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row new-row">
          <div class="col-1"><span>Año: </span></div>
          <div class="col-3">
            <select v-model="Ano" class="form-control">
              <option v-for="anio in listaAnos" :value=anio>{{anio}}</option>
            </select>
          </div>
          <div class="col-1"><span>Trimestre: </span></div>
          <div class="col-3">
            <select v-model="Trimestre" class="form-control">
              <option value="1">Enero - Marzo</option>
              <option value="2">Abril - Junio</option>
              <option value="3">Julio - Septiembre</option>
              <option value="4">Octubre - Diciembre</option>
            </select>
          </div>
          <div class="col-1"><input type="button" class="form-control" @click="GetReportePorcentajeEvaluaciones" value="Calcular"/></div>
        </div>
        
        <div class="row new-row">
          <div class="col-12" >
            <table class="table table-striped table-light table-hover" id="tablaResultados">
              <thead class="thead-dark">
                <tr>
                  <th>Interinatos</th>
                  <th>De Base</th>
                </tr>
              </thead>
              <tbody class='text-dark'>
                <tr>
                  <td>
                    <ul>
                      <li><b>Personal de Interinato: </b>{{cantidadPersonalInterinato}}</li>
                      <li><b>Personal de Interinato Evaluado: </b>{{cantidadPersonalEvaluadoInterinato}} ({{porcentajeInterinatoEvaluado}}%)</li>
                    </ul>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import Vue from 'vue'
  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'
  export default {
    data() {
      return {
        Ano: 2020,
        Trimestre: 1,
        listaAnos: [],
        cantidadPersonalInterinato: 0,
        cantidadPersonalEvaluadoInterinato: 0,
        porcentajeInterinatoEvaluado: 0
      }
    },
    components: {

    },
    methods: {
      GetReportePorcentajeEvaluaciones: function () { //Retorna una lista de evaluaciones pendientes en base a ciertos filtros
        //Carga la información necesaria para hacer la petición
        var peticion = {
          "esPrueba": false,
          "Ano": this.Ano,
          "Trimestre": this.Trimestre
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.GetReportePorcentajeEvaluaciones, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            //console.log(response)
            this.cantidadPersonalInterinato = response.data.CantidadPersonalInterinato;
            this.cantidadPersonalEvaluadoInterinato = response.data.CantidadPersonalEvaluadoInterinato;
            this.porcentajeInterinatoEvaluado = (this.cantidadPersonalEvaluadoInterinato / this.cantidadPersonalInterinato * 100).toFixed(2);

            comun.SeEstaCargandoInformacion(false);
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      llenarListaAnos: function () {
        var i;
        for (i = 2020; i <= this.Ano; i++) {
          this.listaAnos.push(i);
        }
      }
    }, mounted: function mounted() {//Al cargarse la vista hace la busqueda de evaluaciones sin filtros
      this.GetReportePorcentajeEvaluaciones();
      this.Ano = new Date().getFullYear();
      this.Trimestre = 1;
      this.llenarListaAnos();
    }
  }




</script>

<style scoped>
  .new-row {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SISEVA/Evaluaciones/ReportePorcentajeEvaluaciones.vue